<template>
    <div style="width:100%; box-sizing: border-box; text-align: left;">
    <GrcDB ref="GRCDB"></GrcDB>    
    <GrcDialog ref="Dialog"></GrcDialog>

    <div style="width:100%; box-sizing:border-box; max-width:500px; margin:0px auto; display:block;">

        <GrcText ref="txtUjJelszo"
        grc_ispassword="true"
        grc_labeltext="Jelszó:"
        grc_placeholder="..."
        grc_labelmode="" grc_labelwidth="200px" 
        v-on:grc-keydown-enter="SetControlToFocus('txtJelszoConfirm');"
        v-on:grc-innervaluechanged="JelszoKeydownOccured"
        style="margin-bottom:4px;"
        />
        <GrcPasswordStrength ref="pwdstrength" style="margin-bottom:30px;" />

        <GrcText ref="txtJelszoConfirm"
        grc_ispassword="true"
        grc_labeltext="Jelszó megerősítése:"
        grc_placeholder="..."
        grc_labelmode="" grc_labelwidth="200px" 
        style="margin-bottom:20px;"
        />

        <div style="width:100%; box-sizing:border-box; text-align:center;">

            <span class="cms_linkbutton cms_linkbutton_2" style="margin: 4px 8px;" @click="btnOK_click">
                <span><i class="fal fa-check" style="margin-right:10px;"></i>Mentés</span>
            </span>

            <span class="cms_linkbutton cms_linkbutton_CANCEL" style="margin: 4px 8px;" @click="btnMegsem_click">
                <span><i class="fal fa-times" style="margin-right:10px;"></i>Mégsem</span>
            </span>

        </div>   



    </div>


    </div>
</template>

<script>

import GrcText from '../GrcComponents/GrcText.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'

import GrcPasswordStrength from '../GrcComponents/GrcPasswordStrength.vue'


export default {
  name: 'frmjelszovisszaallitas',
  components: {
      GrcDB,
      GrcDialog,
      GrcText,
      GrcPasswordStrength
  },
  props: {

  },
  data () {
      return {
          WSPREFIX: "frmJelszoVisszaallitas_",

          Azonosito:"",
      }
  },
  model: {

  },  
  methods:{

    scrollToTop() { window.scrollTo(0,0); },

    JelszoKeydownOccured(pValue)
    {
      this.$refs.pwdstrength.SetValue(pValue);
    },

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmJelszoVisszaallitas", pCompName);
    },

    SetLang()
    {
        this.$refs.pwdstrength.Init(12, grcmain_GetTextBookItem("tech", "password_strength_title"));

        this.HideErrors();

        this.Init();
    },

    async Init()
    {
        this.Azonosito = "";

        this.InfoText = "";

        if (GRCAPP_GetParameters.hasOwnProperty("DATA"))
        {
          this.Azonosito = GRCAPP_GetParameters.DATA;
        }

        this.scrollToTop();

        this.$refs.GRCDB.ShowLoading(false);

        var QP = {
            sAzonosito: this.Azonosito,
        };
        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX+"Init", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            await this.ShowInfo(Q.APPERR[0].ERR, 200);
            document.location = "bejelentkezes";
            return;
        }

        this.$refs.GRCDB.HideLoading();

        if (Q.RESULT[0].intResult == 0)
        {
            await this.ShowInfo("A jelszó módosítás érvényességi ideje lejárt!", 250);
            document.location = "bejelentkezes";
        }
    },


      SetControlToFocus(pNextComp)
      {
        if (pNextComp == "") { return; }
        this.$refs[pNextComp].SetFocus();
      },

      btnOK_click()
      {
        this.Mentes();
      },

      btnMegsem_click()
      {
        document.location = "bejelentkezes";
      },

      HideErrors()
      {
        this.$refs.txtUjJelszo.HideError();
        this.$refs.txtJelszoConfirm.HideError();
      },


      async Mentes()
      {
        this.HideErrors();

        var ErrorCompName = "";


        if (this.$refs.txtUjJelszo.GetText() == "")
        {
          if (ErrorCompName == "") { ErrorCompName = "txtUjJelszo"; }
          this.$refs.txtUjJelszo.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }
        else
        {
          if (this.$refs.pwdstrength.GetStatusz() == false)
          {
            if (ErrorCompName == "") { ErrorCompName = "txtUjJelszo"; }
            this.$refs.txtUjJelszo.ShowError(grcmain_GetTextBookItem("tech", "weak_password_warning"));
          }
        }

        if (this.$refs.txtJelszoConfirm.GetText() == "")
        {
          if (ErrorCompName == "") { ErrorCompName = "txtJelszoConfirm"; }
          this.$refs.txtJelszoConfirm.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }


        if ((this.$refs.txtUjJelszo.GetText() != "") && (this.$refs.txtJelszoConfirm.GetText() != "") && (this.$refs.txtUjJelszo.GetText() != this.$refs.txtJelszoConfirm.GetText()))
        {
          if (ErrorCompName == "") { ErrorCompName = "txtUjJelszo"; }
          this.$refs.txtUjJelszo.ShowError(grcmain_GetTextBookItem("tech", "password_confirm_mismatch"));
        }



        if (ErrorCompName != "")
        {
          this.SetControlToFocus(ErrorCompName);
          return;
        }


        this.$refs.GRCDB.ShowLoading(false);

        var QP = { 
            sAzonosito: this.Azonosito,
            sUjJelszo: this.$refs.txtUjJelszo.GetText(),
        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "Mentes", QP).then(res => { Q = res; });

        
        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            await this.ShowInfo(Q.APPERR[0].ERR, 200);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        await this.ShowInfo(Q.RESULT[0].strResult, 200);

        if (Q.RESULT[0].intResult == 1)
        {
            document.location = "bejelentkezes";
        }

      },

    async ShowInfo(pText, pHeight)
    {
        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = -1;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
        });               
    },





  },
  created()
  {

  },
  mounted()
  {
    this.SetLang();
  }

}


</script>


<style scoped>


</style>